import { gql } from "@apollo/client";

export const DELETE_DOCUMENT = gql`
  mutation DeleteDocument($documentMrn: String!) {
    deleteDocument(documentMRN: $documentMrn)
  }
`;
